import { C } from "../constants";
import { Sec, STitle, ContentBlock } from "../components/Shared";

export default function ForUsers() {
  return (
    <div>
      <Sec>
        <STitle tag="For Users" title="What to expect" sub="SafeZapp lets you chat with your approved contacts — with some sensible guardrails in place." />

        <div style={{ maxWidth: 720, margin: "0 auto" }}>
          <ContentBlock icon="💬" title="You can chat with approved contacts">
            <p style={{ margin: 0 }}>Once your approver has linked with you and approved your contacts, you can message them freely. Adding a new contact? Just send a request — your approver will get a notification and can approve it quickly.</p>
          </ContentBlock>

          <ContentBlock icon="🤖" title="SafeZapp helps you communicate kindly">
            <p style={{ margin: 0 }}>If you try to send something that might be hurtful, SafeZapp will suggest a better way to say it. You can send the kinder version with one tap. It's not about getting you in trouble — it's about helping you be the best communicator you can be.</p>
          </ContentBlock>

          <ContentBlock icon="👀" title="What your approver can see">
            <p style={{ margin: 0 }}>Your approver can see who your contacts are and approve new contact requests. They cannot read your messages.</p>
          </ContentBlock>

          <ContentBlock icon="🔒" title="Your privacy matters">
            <p style={{ margin: 0 }}>We don't collect your date of birth. We don't build a profile about you. We don't sell your data. The only information we hold is what's needed for the app to work. And if your account ever gets unlinked, your data is automatically deleted after 14 days.</p>
          </ContentBlock>

          <ContentBlock icon="⚡" title="Getting started">
            <p style={{ margin: 0 }}>Ask your approver to download SafeZapp and generate a pairing code. Then download the app yourself, enter the code, and wait for them to approve the link. Once you're connected, you're good to go.</p>
          </ContentBlock>

          <div style={{
            background: C.blueLight, borderRadius: 14, padding: "20px 24px", marginTop: 24,
            border: `1px solid ${C.border}`
          }}>
            <p style={{ fontFamily: "'Nunito', sans-serif", fontSize: 14.5, color: C.text, margin: 0, lineHeight: 1.7 }}>
              <strong>Have a question or concern?</strong> You can reach us anytime at <a href="mailto:support@safezapp.com" style={{ color: C.blue, fontWeight: 600 }}>support@safezapp.com</a>. We take every message seriously.
            </p>
          </div>
        </div>
      </Sec>
    </div>
  );
}
